// Init smooth-scrollbar
const Scrollbar = window.Scrollbar

Scrollbar.initAll({
    alwaysShowTracks: true
})